<template>
  <div class="content">
    <div class="row">
      <div class="col-lg-3">
        <card class="card-login card-white text-left">
          <div class="w-100 d-flex justify-content-center p-1">
            <div v-if="loadImgRecente" class="d-flex align-items-center">
              <strong>Carregando Foto...</strong>
              <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
            </div>

            <div v-else class="w-100 d-flex justify-content-center">
              <img v-if="imgRecente" :src="'data:image/png;base64,' + imgRecente" alt="Card image"
                class="img img-raised" />
              <img v-else src="../../public/img/anime4.png" alt="paciente" class="img-thumbnail"
                style="border-radius: 50%; width: 50%;" />
            </div>
          </div>
          <div class="mt-3 p-2">
            <p class="text-muted">
              <strong>Empresa:</strong> {{ this.dados.NM_FANTASIA_EMPREGADOR }}
            </p>
            <p class="text-muted">
              <strong>Funcionário:</strong> {{ this.dados.NOME_EMPREGADO }}
            </p>
            <p class="text-muted">
              <i class="tim-icons icon-calendar-60"></i>
              {{
                moment(new Date())
                  .add(1, "hour")
                  .format("DD/MM/YYYY")
              }}
              - <i class="tim-icons icon-watch-time"></i> {{ horaAgora }}
            </p>
          </div>
          <div class="mt-2">
            <base-button @click="registrarPonto" native-type="submit" type="success" class="mb-3" size="lg" block>
              Registrar Ponto
            </base-button>
          </div>
        </card>
      </div>

      <div class="col-lg-9">
        <card class="card-login card-white pt-0 d-flex justify-content-center">
          <div class="col-sm-6 ml-auto mr-auto" v-if="showRecFacial == 1">
            <base-button @click="showRecFacial = 2" native-type="submit" type="success" class="mb-3" size="lg" block>
              Listagem de Pontos
            </base-button>
          </div>

          <div class="col-sm-6 ml-auto mr-auto" v-else-if="showRecFacial == 2">
            <h5 slot="header" class="card-title text-left">
              Para visualizar o seu histórico realize o reconhecimento facial.
            </h5>
            <modal-rec-facial-2 />
          </div>

          <div class="col-sm-10 ml-auto mr-auto" v-else-if="showRecFacial == 3">
            <div class="row">
              <div class="col-md-6 text-left">
                <h4 slot="header" class="card-title text-left">
                  Listagem de Ponto
                </h4>
              </div>
              <div class="col-md-6 d-flex justify-content-end">
                <el-select class="select-primary" size="large" placeholder="Single Select" v-model="mes">
                  <el-option class="select-primary" value="01" label="Janeiro" key="Janeiro">Janeiro</el-option>
                  <el-option class="select-primary" value="02" label="Fevereiro" key="Fevereiro">Fevereiro</el-option>
                  <el-option class="select-primary" value="03" label="Março" key="Março">Março</el-option>
                  <el-option class="select-primary" value="04" label="Abril" key="Abril">Abril</el-option>
                  <el-option class="select-primary" value="05" label="Maio" key="Maio">Maio</el-option>
                  <el-option class="select-primary" value="06" label="Junho" key="Junho">Junho</el-option>
                  <el-option class="select-primary" value="07" label="Julho" key="Julho">Julho</el-option>
                  <el-option class="select-primary" value="08" label="Agosto" key="Agosto">Agosto</el-option>
                  <el-option class="select-primary" value="09" label="Setembro" key="Setembro">Setembro</el-option>
                  <el-option class="select-primary" value="10" label="Outubro" key="Outubro">Outubro</el-option>
                  <el-option class="select-primary" value="11" label="Novembro" key="Novembro">Novembro</el-option>
                  <el-option class="select-primary" value="12" label="Dezembro" key="Dezembro">Dezembro</el-option>
                </el-select>
              </div>
            </div>

            <div class="table-responsive-sm">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">Data</th>
                    <th scope="col">ENT1</th>
                    <th scope="col">SAÍ1</th>
                    <th scope="col">ENT2</th>
                    <th scope="col">SAÍ2</th>
                    <th scope="col">ENT3</th>
                    <th scope="col">SAÍ3</th>
                    <th scope="col">ENT4</th>
                    <th scope="col">SAÍ4</th>
                    <th scope="col">Ações</th>
                    <!-- <th scope="col">Local</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in tableData" :key="item.data">
                    <td>{{ item.data }}</td>
                    <td>
                      <a style="cursor: pointer;" class="btn-link" data-toggle="tooltip" data-placement="top"
                        title="Abrir no mapa" v-if="item.batidas.length > 0"
                        @click="handleOpenLocation(item.dadosBatidas[0])">
                        {{ moment(item.batidas[0]).format('HH:mm') }}
                      </a>
                      <a class="btn-link" v-else>
                        -
                      </a>
                    </td>

                    <td>
                      <a style="cursor: pointer;" class="btn-link" data-toggle="tooltip" data-placement="top"
                        title="Abrir no mapa" v-if="item.batidas.length > 1"
                        @click="handleOpenLocation(item.dadosBatidas[1])">
                        {{ moment(item.batidas[1]).format('HH:mm') }}
                      </a>
                      <a class="btn-link" v-else>
                        -
                      </a>
                    </td>

                    <td>
                      <a style="cursor: pointer;" class="btn-link" data-toggle="tooltip" data-placement="top"
                        title="Abrir no mapa" v-if="item.batidas.length > 2"
                        @click="handleOpenLocation(item.dadosBatidas[2])">
                        {{ moment(item.batidas[2]).format('HH:mm') }}
                      </a>
                      <a class="btn-link" v-else>
                        -
                      </a>
                    </td>

                    <td>
                      <a style="cursor: pointer;" class="btn-link" data-toggle="tooltip" data-placement="top"
                        title="Abrir no mapa" v-if="item.batidas.length > 3"
                        @click="handleOpenLocation(item.dadosBatidas[3])">
                        {{ moment(item.batidas[3]).format('HH:mm') }}
                      </a>
                      <a class="btn-link" v-else>
                        -
                      </a>
                    </td>

                    <td>
                      <a style="cursor: pointer;" class="btn-link" data-toggle="tooltip" data-placement="top"
                        title="Abrir no mapa" v-if="item.batidas.length > 4"
                        @click="handleOpenLocation(item.dadosBatidas[4])">
                        {{ moment(item.batidas[4]).format('HH:mm') }}
                      </a>
                      <a class="btn-link" v-else>
                        -
                      </a>
                    </td>

                    <td>
                      <a style="cursor: pointer;" class="btn-link" data-toggle="tooltip" data-placement="top"
                        title="Abrir no mapa" v-if="item.batidas.length > 5"
                        @click="handleOpenLocation(item.dadosBatidas[5])">
                        {{ moment(item.batidas[5]).format('HH:mm') }}
                      </a>
                      <a class="btn-link" v-else>
                        -
                      </a>
                    </td>

                    <td>
                      <a style="cursor: pointer;" class="btn-link" data-toggle="tooltip" data-placement="top"
                        title="Abrir no mapa" v-if="item.batidas.length > 6"
                        @click="handleOpenLocation(item.dadosBatidas[6])">
                        {{ moment(item.batidas[6]).format('HH:mm') }}
                      </a>
                      <a class="btn-link" v-else>
                        -
                      </a>
                    </td>

                    <td>
                      <a style="cursor: pointer;" class="btn-link" data-toggle="tooltip" data-placement="top"
                        title="Abrir no mapa" v-if="item.batidas.length > 7"
                        @click="handleOpenLocation(item.dadosBatidas[7])">
                        {{ moment(item.batidas[7]).format('HH:mm') }}
                      </a>
                      <a class="btn-link" v-else>
                        -
                      </a>
                    </td>
                    <td>
                      <el-tooltip content="Baixar Pontos" effect="light" :open-delay="300" placement="top">
                        <base-button @click.native="baixarPontos(item)" class="edit btn-link" type="info" size="sm"
                          icon>
                          <i class="tim-icons icon-cloud-download-93"></i>
                        </base-button>
                      </el-tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-sm-4 ml-auto mr-auto" v-else></div>
        </card>
      </div>
    </div>
    <Carregando v-if="isLoading" />
    <PopupInformativo/>
  </div>
</template>
<script>
import Carregando from "../../src/pages/Loads/Carregando.vue";
import { Card, BasePagination, PopupInformativo } from "@/components/index";
import moment from "moment-timezone";
import ModalRecFacial2 from "../../src/pages/Components/ModalRecFacial2.vue";
import swal from "sweetalert2";

import { Table, TableColumn } from "element-ui";

export default {
  components: {
    Carregando,
    Card,
    ModalRecFacial2,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    PopupInformativo,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
  },
  data() {
    return {
      mes: 0,
      isLoading: false,
      nColunas: 0,
      imgRecente: "",
      showRecFacial: 1,
      searchedData: "",
      horaAgora: "",
      loadImgRecente: true,

      tableColumns: [
        {
          prop: "name",
          label: "Name",
          minWidth: 200,
        },
        {
          prop: "email",
          label: "Email",
          minWidth: 250,
        },
        {
          prop: "age",
          label: "Age",
          minWidth: 100,
        },
        {
          prop: "salary",
          label: "Salary",
          minWidth: 120,
        },
      ],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      tableData: [],
      tableDataSearch: [],
      dados: "",
    };
  },
  mounted() {
    setTimeout(() => {
      this.mes = this.moment().format("MM");
    }, 1500);

    this.carregarFotoF();
    this.$root.$on("checkFacial", (data) => {
      if (data) {
        this.showRecFacial = 3;
        this.listarPontosFuncionarios(this.moment(new Date()).format("MM"));
      }
    });

    setInterval(() => {
      this.horaAgora = moment().tz(this.dados.FUSO ? this.dados.FUSO : "America/Manaus")
        .add(0, "hour")
        .format("HH:mm:ss");
    }, 1000);
  },
  methods: {
    baixarPontos(item) {
      const bodyFormData = {
        setDB: this.dados.DB_NAME,
        pontos: item.dadosBatidas.map(db => db.id),
        id_empregado: this.dados.ID_EMPREGADO,
      };

      this.axios
        .post("/api/movimentacoes/baixarPontos", bodyFormData, {
          responseType: 'blob', // importante para receber o PDF corretamente
        })
        .then((response) => {
          this.isLoading = false;
          if (response.status === 200) {
            // Criar um URL temporário para o Blob
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const downloadUrl = window.URL.createObjectURL(blob);

            // Criar um link temporário
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', 'batidas.pdf'); // Nome do arquivo

            // Adicionar o link ao documento e clicar nele
            document.body.appendChild(link);
            link.click();

            // Remover o link depois
            link.remove();
          } else {
            this.showSwal(
              "auto-close",
              "Erro",
              "Erro ao baixar pontos selecionados",
              "error"
            );
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.error("Erro na requisição:", err);
        });
    },

    carregarDados() {
      this.dados = JSON.parse(this.$session.get("dados"));
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    registrarPonto() {
      if (this.dados.TIPO_BATIDA == 2) {

        this.showSwal(
          "auto-close",
          "Registro não autorizado",
          "Solicite ao seu RH liberação para registro de ponto Facial.",
          "error"
        );
        return;
      }
      this.$router.push('/registrarPonto');
    },

    moment: function (data) {
      return moment(data);
    },

    handleOpenLocation(row) {
      window.open(
        `https://www.google.com/maps/search/${row.latitude},${row.longitude}/@${row.latitude},${row.longitude},21z`,
        "_blank"
      );
      // window.open(`https://www.google.com.br/maps/@${row.LATITUDE_BATIDA},${row.LONGITUDE_BATIDA},21z`, "_blank");
    },

    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from(), this.to());
    },
    to() {
      let highBound = this.from() + this.pagination.perPage;
      if (this.total() < highBound) {
        highBound = this.total();
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },

    carregarFotoF() {
      let th = this;
      let jsonn = new FormData();
      jsonn.append("nrCpf", this.dados.CPF_EMPREGADO);

      this.axios
        .post(
          `${process.env.VUE_APP_API_ADDRESS_REC_FACIAL}/getFotoRecente`,
          jsonn
        )
        .then((response) => {
          th.loadImgRecente = false;
          th.imgRecente = response.data.ImagemRecente;
        })
        .finally(() => { })
        .catch(() => { });
    },

    listarPontosFuncionarios(mes) {
      let th = this;
      this.isLoading = true;

      const bodyFormData = {
        setDB: this.dados.DB_NAME,
        id_empregador: this.dados.ID_EMPREGADOR,
        id_empregado: this.dados.ID_EMPREGADO,
        idMes: mes,
      };
      this.axios
        .post(
          "/api/movimentacoes/listarMovimentacoesPorIdEmpregadoPorMes",
          bodyFormData
        )
        .then((response) => {
          th.isLoading = false;
          th.tableData = response.data.data.dados;
          th.tableDataSearch = response.data.data.dados;

          let cont = 0;
          let cont2 = 0;

          th.tableData.map((dados) => {
            cont = 0;
            dados.horarios_batidas.map((data) => {
              cont++;
            });
            if (cont2 < cont) {
              cont2 = cont;
            }
          });

          if (cont2 > 8) {
            cont2 = 8;
          }

          th.nColunas = cont2;
          // alert(cont)

          // th.tableData = response.data.data.dados
          // th.carregarFuse()
        })
        .catch((err) => {
          th.isLoading = false;
        });
    },
  },

  watch: {
    mes(newVal) {
      this.listarPontosFuncionarios(newVal);

      /* this.tableData = this.tableDataSearch.filter((dados) => {
        if(dados.data.substr(3, 2) == newVal){
          return dados
        }
      }) */
    },
  },

  created() {
    this.carregarDados();
  },
};
</script>
<style>
#worldMap .datamap {
  left: 0 !important;
}

.text-h4 {
  padding: 0px 10px 0px 10px;
  margin: 10px 0px 0px 0px;
}

.text-p {
  text-align: left;
  padding: 0px 20px 0px 20px;
}
</style>
